import React, {forwardRef} from 'react';
import {Alert, AlertTitle, Box, Link, Typography} from '@mui/material';
import {OutstandingReviewIssue} from '../assets/review-issues';

/**
 * The stored-data problems the visitor must fix before signing, each with a link to the editor that fixes it.
 * Issues the visitor cannot fix on the page (not blocking) are listed without a link.
 */
export const ReviewIssuesAlert = forwardRef<HTMLDivElement, {
    issues: OutstandingReviewIssue[];
    onFix: (issue: OutstandingReviewIssue) => void;
}>(({issues, onFix}, ref) => {
    if (!issues.length) return null;
    const blocking = issues.some(issue => issue.blocking);
    return <Alert ref={ref} severity="warning" sx={{mt: 3, scrollMarginTop: 80}}>
        <AlertTitle>{blocking ? 'Please update these details before you sign' : 'Please review these details'}</AlertTitle>
        <Typography variant="body2" sx={{mb: 1}}>
            {blocking ? 'The state will not accept the reinstatement with the company information below as it is on file. '
                + 'Correct each item, then proceed to payment.' : 'These details may need attention.'}
        </Typography>
        <Box component="ul" sx={{m: 0, pl: 2.5}}>
            {issues.map((issue, index) => <li key={`${issue.field}-${index}`}>
                <Typography variant="body2" component="span">{issue.message}</Typography>
                {issue.blocking && <> <Link component="button" type="button" variant="body2" sx={{verticalAlign: 'baseline', fontWeight: 700}}
                                           onClick={() => onFix(issue)}>Fix</Link></>}
            </li>)}
        </Box>
        {issues.some(issue => !issue.blocking) && <Typography variant="body2" sx={{mt: 1}}>
            If you can't correct an item here, <Link href="mailto:support@fcfiling.com">contact support</Link>.
        </Typography>}
    </Alert>;
});
